import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SideEvent"] */ "/workspace/src/components/moleculer/events/2024techfes/sideEvent.tsx");
